import type { EstimateType } from "@rebuild/shared";
import { EstimateType as ToolsEstimateType } from "../CreatorTools/MappingTool/utils/EstimateType";

export const ESTIMATE_TYPES = Object.values(ToolsEstimateType) as unknown as EstimateType[];
